'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

import SvgIcons from './SvgIcons';
import productData from './ProductData';

const Ourproducts = () => {
  return (
    <div style={{ background: 'radial-gradient(159.84% 50% at 50% 50%, #F5F5F5 0%, #FFFFFF 100%)' }}>
      <div className='testi_con_all container mx-auto'>
        <div className='flex justify-center mb-[80px] items-center gap-4'>
          <SvgIcons.Lines className='w-[50px] md:w-[86px]' />
          <p className="bg-gradient-to-r w-fit text-center from-[#1A5D6B] to-[#33B6D1] bg-clip-text text-transparent font-NeueMontrealBold text-[18px] md:text-4xl font-bold leading-normal">
            Our Products
          </p>
          <SvgIcons.Lines className='w-[50px] md:w-[86px]' />
        </div>

        <div className='top-selling-prod py-3 container-fluid relative'>
          <Swiper
            spaceBetween={10}
            centeredSlides={true}
            slidesPerView={1}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            navigation={{
              nextEl: '.swiper-button-next-custom3',
              prevEl: '.swiper-button-prev-custom3',
            }}
            loop={true}
            modules={[Autoplay, Navigation]}
            className='mySwiper3'
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 16 },
              480: { slidesPerView: 2, spaceBetween: 16 },
              768: { slidesPerView: 3, spaceBetween: 16 },
              1024: { slidesPerView: 3.5, spaceBetween: 16 },
            }}
          >
            {productData.products.map((product) => (
              <SwiperSlide key={product.id}>
                <Link
                  href={`/products/${product.url}`}
                  className='block rounded-[12px] h-full bg-[#CCF2FA] shadow-[0_0_18.487px_0_rgba(0,0,0,0.10)] p-[16px] transition-transform duration-300 ease-in-out hover:scale-[1.02]'
                >
                  <Image
                    src={product.image}
                    alt={product.title}
                    width={300}
                    height={300}
                    loading='lazy'
                    className='w-full h-auto object-contain rounded-t-[12px]'
                    placeholder='blur'
                    blurDataURL='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8/5+pPwAEdQIZO3Eu8gAAAABJRU5ErkJggg=='
                    style={{ aspectRatio: '1 / 1' }}
                  />
                  <p className="text-[#00819E] mt-[17px] text-center font-['DM_Sans'] text-[20px] !font-medium leading-normal">
                    {product.title}
                  </p>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className='flex justify-center md:!mt-0 !mt-3'>
            <div className='!absolute md:!bottom-10 !bottom-0 md:!w-[100%] w-[70%] flex justify-between items-center px-4'>
              <div className='swiper-button-prev-custom3'><SvgIcons.SwipperLeftArrow /></div>
              <div className='swiper-button-next-custom3'><SvgIcons.SwipperRightArrow /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Ourproducts };
